/* eslint-disable brace-style */
/* eslint-disable indent */

import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import {
  MatDateRangeSelectionStrategy,
  DateRange,
} from '@angular/material/datepicker';

@Injectable()
/**
 * Defines range strategy for datepickers around the application
 */
export class MaxRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  start: any;
  public deltaInMonths: number = 24;

  /**
   * Constructor
   * @param {DateAdapter<D>} _dateAdapter
   */
  constructor(private _dateAdapter: DateAdapter<D>) {}

  /**
   * Executes the selection of the range
   * @param {D} date
   * @param {DateRange<D>} currentRange
   * @return {DateRange<D>}
   */
  selectionFinished(date: D, currentRange: DateRange<D>): DateRange<D> {
    let { start, end } = currentRange;

    if (start === null || (start && end)) {
      start = date;
      end = null;
    } else if (end === null) {
      const maxDate = this._dateAdapter.addCalendarMonths(
        start,
        this.deltaInMonths
      );
      if (date && this._dateAdapter.compareDate(date, maxDate) > 0) {
        end = maxDate;
      } else {
        end = date ?? null;
      }
    }

    return new DateRange<D>(start, end);
  }

  /**
   * Creates the range preview on the datepicker
   * @param  {D | null} activeDate
   * @param {DateRange<D>} currentRange
   * @return {DateRange<D>}
   */
  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this._dateAdapter.addCalendarMonths(
        currentRange.start,
        this.deltaInMonths
      );
      let rangeEnd: D | null;
      if (
        activeDate &&
        this._dateAdapter.compareDate(activeDate, maxDate) > 0
      ) {
        rangeEnd = maxDate;
      } else {
        rangeEnd = activeDate ?? null;
      }

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}
